"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../config/types");
const impermax_factories_1 = require("../../config/contracts/impermax-factories");
class OnchainPairConfig {
    constructor(proposal, pairConfig) {
        this.getProposal = () => this.proposal;
        this.getPairConfigData = () => this.pairConfig;
        this.getOnchain = () => this.proposal.getOnchain();
        this.getBorrowableA = () => this.getBorrowableConfig(types_1.PoolTokenType.BorrowableA);
        this.getBorrowableB = () => this.getBorrowableConfig(types_1.PoolTokenType.BorrowableB);
        this.proposal = proposal;
        this.pairConfig = pairConfig;
    }
    getFactory() {
        return __awaiter(this, void 0, void 0, function* () {
            const factoryAddress = this.pairConfig.factory;
            return (0, impermax_factories_1.getFactoryByAddress)(this.getOnchain().network, factoryAddress);
        });
    }
    getPairAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.pairConfig.pair;
        });
    }
    getLendingPool() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.lendingPool)
                this.lendingPool = (() => __awaiter(this, void 0, void 0, function* () {
                    const impermaxFactory = yield this.getOnchain().getImpermaxFactory(yield this.getFactory());
                    return impermaxFactory.getLendingPool(yield this.getPairAddress());
                }))();
            return this.lendingPool;
        });
    }
    getSafetyMargin() {
        return __awaiter(this, void 0, void 0, function* () {
            return Math.pow((parseInt(this.pairConfig.collateralConfig.safetyMarginSqrt) / 1e18), 2);
        });
    }
    getLiquidationIncentive() {
        return __awaiter(this, void 0, void 0, function* () {
            return parseInt(this.pairConfig.collateralConfig.liquidationIncentive) / 1e18;
        });
    }
    getLiquidationFee() {
        return __awaiter(this, void 0, void 0, function* () {
            return parseInt(this.pairConfig.collateralConfig.liquidationFee) / 1e18;
        });
    }
    getWhitelisted() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.pairConfig.whitelistState !== '0';
        });
    }
    getBorrowableConfig(poolTokenType) {
        const borrowableConfig = poolTokenType == types_1.PoolTokenType.BorrowableA
            ? this.pairConfig.borrowable0Config
            : this.pairConfig.borrowable1Config;
        return {
            getReserveFactor: () => __awaiter(this, void 0, void 0, function* () {
                return parseInt(borrowableConfig.reserveFactor) / 1e18;
            }),
            getKinkUtilizationRate: () => __awaiter(this, void 0, void 0, function* () {
                return parseInt(borrowableConfig.kinkUtilizationRate) / 1e18;
            }),
            getAdjustSpeed: () => __awaiter(this, void 0, void 0, function* () {
                return parseInt(borrowableConfig.adjustSpeed) / 1e18;
            }),
            getBorrowTracker: () => __awaiter(this, void 0, void 0, function* () {
                return borrowableConfig.borrowTracker;
            }),
        };
    }
}
exports.default = OnchainPairConfig;
